import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Roster from './pages/Roster';
import Projects from './pages/Projects';
import Services from './pages/Services';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/roster" element={<Roster />} />
           <Route path="/artists" element={<Roster />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/services" element={<Services />} />

        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;